import "./Studio.module.css";
import Header from "@/reusable_sections/Header";
import Statement from "./sections/Statement";
import Philosophy from "./sections/Philosophy";
import Showcase from "./sections/Showcase";
import Services from "./sections/Services";
import TeamGrid from "./sections/TeamGrid";
import FoundersEditorial from "./sections/FoundersEditorial";
import Footer from "./sections/Footer";
export default function StudioPage() {
  return <div>
      <Header />
      <Statement />
      <Philosophy />
      <Showcase />
      <Services />
      
      <FoundersEditorial />
      <Footer />
    </div>;
}